







































import Vue from 'vue'
import { CardType } from '../../models'
import { setSet, getCard, copyToClipboard } from '../../assets/utility'
import store from '../../store'
export default Vue.extend({
  name: 'Card',
  props: {
    card: {
      type: CardType,
      default: new CardType({})
    },
    deckId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      mode: 'question'
    }
  },
  computed: {
    user () {
      return store.state.user
    },
    askLogin () {
      return store.state.askLogin
    }
  },
  methods: {
    choseYes () {
      let appreciations = ['Amazing! 👍', 'Keep it up! 👍']
      let appreciation = appreciations[Math.floor(Math.random() * appreciations.length)]
      this.$toasted.show(appreciation, { type: 'success', duration: 3000 })
    },
    copyLink () {
      let link = `${location.origin}/share/${this.deckId}/${this.card.id}`
      copyToClipboard(link)
      this.$toasted.show('Copied! 👍', { type: 'success', duration: 3000 })
      // setTimeout(function () {
      //   window.open(link, '_blank')
      // }, 0)
    },
    async addCard () {
      if (this.askLogin) {
        this.$toasted.show('Login to remember it forever🙂', { type: 'info', duration: 3000 })
        this.$emit('showLogin')
        return
      }
      console.log('TCL: addCard -> cardId, currentDeck', this.card.id)
      try {
        let result = await getCard(this.user.uid, this.card.id)
        // console.log('TCL: addCard -> result', result)
        if (result.exists) {
          this.$toasted.show('Already added to your backpack 👍', { type: 'error', duration: 5000 })
          return
        }
        await setSet({ collection: `decks/${this.user.uid}/cards`, doc: this.card.id, data: new CardType({ front: this.card.front, back: this.card.back }).toString(), merge: true })
        this.$toasted.show('Card added! 👍', { type: 'success', duration: 5000 })
      } catch (err) {
        this.$toasted.show('Unable to add. 😟', { type: 'error', duration: 5000 })
        console.log('TCL: addCard -> err', err)
      }
    }
  }
})
